function BottomBar({
  contextText,
  primaryLabel,
  onPrimary,
  primaryDisabled,
  secondaryLabel,
  onSecondary,
  secondaryDisabled,
  tertiaryLabel,
  onTertiary,
  tertiaryDisabled,
}) {
  return (
    <div className="bottom-bar-wrap" role="region" aria-label="Session actions">
      <div className="bottom-bar page-shell">
        {contextText ? (
          <div className="bottom-bar-context">
            <p className="section-title">Session actions</p>
            <p className="muted-text">{contextText}</p>
          </div>
        ) : null}
        <div className="bottom-bar-actions">
          <button
            type="button"
            className="btn btn-primary"
            onClick={onPrimary}
            disabled={primaryDisabled}
          >
            {primaryLabel}
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onSecondary}
            disabled={secondaryDisabled}
          >
            {secondaryLabel}
          </button>
          <button
            type="button"
            className="btn btn-tertiary"
            onClick={onTertiary}
            disabled={tertiaryDisabled}
          >
            {tertiaryLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

export default BottomBar;
